import { NormalizedNumber } from '@sparkdotfi/common-universal'

import { TransferFromUserValidationIssue } from '@/features/dialogs/common/logic/transfer-from-user/validation'
import { SavingsConverter } from '@/features/savings/logic/savings-converters/types'
import { EPOCH_LENGTH } from '@/features/sparklend/common/data/market-info/consts'

export type DepositToSavingsValidationIssue =
  | TransferFromUserValidationIssue
  | 'exceeds-psm3-balance'
  | 'exceeds-remaining-cap'

export const depositValidationIssueToMessage: Record<DepositToSavingsValidationIssue, string> = {
  'value-not-positive': 'Deposit value should be positive',
  'exceeds-balance': 'Exceeds your balance',
  'exceeds-psm3-balance': 'Savings deposit cap temporarily reached',
  'exceeds-remaining-cap': 'Savings deposit cap temporarily reached',
}

export interface ValidateDepositToSavingsOnBaseParams {
  psm3SusdsBalance: NormalizedNumber
  estimatedSusdsReceived: NormalizedNumber
}
export function validateDepositToSavingsWithPsm3({
  psm3SusdsBalance,
  estimatedSusdsReceived,
}: ValidateDepositToSavingsOnBaseParams): DepositToSavingsValidationIssue | undefined {
  if (psm3SusdsBalance.lt(estimatedSusdsReceived)) {
    return 'exceeds-psm3-balance'
  }
}

export interface ValidateCapAwareDepositToSavingsParams {
  timestamp: number
  totalSupply: NormalizedNumber
  cap: NormalizedNumber
  value: NormalizedNumber
  savingsConverter: SavingsConverter
}

export function validateCapAwareDepositToSavings({
  timestamp,
  totalSupply,
  cap,
  value,
  savingsConverter,
}: ValidateCapAwareDepositToSavingsParams): DepositToSavingsValidationIssue | undefined {
  const totalAssetsIn1Epoch = savingsConverter.predictAssetsAmount({
    shares: totalSupply,
    timestamp: timestamp + EPOCH_LENGTH,
  })

  const remainingCapBuffered = NormalizedNumber.max(cap.minus(totalAssetsIn1Epoch), NormalizedNumber.ZERO)

  if (value.gt(remainingCapBuffered)) {
    return 'exceeds-remaining-cap'
  }
}
